<template lang="pug">
    div(
        @click="showFitmentModal"
        class="or-navbar-fitment text-white bg-primary flex items-center justify-center py-2 px-4 cursor-pointer capitalize font-bold"
    )
        template(v-if="!fitmentFormatted")
            FitmentIcon(
                class="w-12 h-10 mr-3 align-top fill-current"
                style="min-width: 50px;"
            )
            span(
                v-if="!fitmentFormatted"
                class="text-lg"
                data-testid="vehicleSelection"
            ) Select Your Vehicle

        template(v-else)
            div(class="flex flex-col leading-tight")
                span(class="text-sm" data-testid="fitmentSelection") {{ fitmentFormatted }}
                span(
                    v-if="fitmentFormattedSecondary"
                    class="text-xs"
                ) {{ fitmentFormattedSecondary }}
            div(
                class="border-l border-solid border-current leading-tight font-normal text-xs ml-auto pl-3 py-1 lg:ml-3"
            ) Change

</template>

<script>
import FitmentIcon from '@/components/fitmentIcon'

export default {
    components: {
        FitmentIcon,
    },
    computed: {
        fitmentFormatted() {
            return this.$store.getters['fitment/fitmentFormatted']
        },
        fitmentFormattedSecondary() {
            return this.$store.getters['fitment/fitmentFormattedSecondary']
        },
    },
    methods: {
        showFitmentModal() {
            this.$store.dispatch('fitment/showFitmentModal')
        },
    },
}
</script>
